skrilla.controller('declinePromotionClaimModalCtrl', function ($scope, cacheService, modalService, searchService, validationService) {
    $scope.claimId = cacheService.getObjectOrElse("declinePromotionClaim", modalService.dismissAll);
    $scope.request = {};
    $scope.validate = {};
    $scope.decline = function () {
        if(validateForm()) {
            modalService.confirm("Are you sure you'd like to decline this promotion claim", function () {
                searchService.put("promotions/claims/" + $scope.claimId + "/decline", $scope.request, "Claim successfully declined").then(function (response) {
                    modalService.dismissAll();
                });
            });
        }
    }

    function validateForm(){
        var inputs = [
            validationService.buildFieldValidationObj("reason", !validationService.isEmpty($scope.request.reason), "Please enter a reason")
        ];
        return validationService.validateForm(inputs, $scope.validate)
    }

});
